import { gql } from '@apollo/client';

export const EscrowTerminationFields = gql`
  fragment EscrowTerminationFields on EscrowTermination {
    id
    status
    terminateAt
    requesterParty
    policy {
      accept
      reject
    }
  }
`;
